/* eslint-disable no-unused-vars */
import slick from 'slick-carousel';

export default () => {

  const $homePageCarousel = $('.js-home-page-carousel-slides'),
        $homePageCarouselBP = 1200
  ;

  const $homePageCarouselSettings = {
    autoplay: true,
    autoplaySpeed: 2000,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 2000,
    fade: true,
    arrows: false,
    accessibility: true,
    dots: true,
    appendDots: '.home-page-carousel-dots',
    customPaging: (el, i) => {
      const dotToolTip = el.$list
        .find('.home-page-carousel-slide')
        .eq(i)
        .data('slide-title');
      return `<button type="button"><span class="tooltip">${dotToolTip}<span><span class="sr-text">${i + 1}</span></button>`;
    }
  };


  // slick/unslick based on breakpoint
  function slickToggle(carousel, settings, breakpoint) {

    // reslick only if it's not slick()
    if ($(window).outerWidth() < breakpoint) {
      if (carousel.hasClass('slick-initialized')) {
        carousel.slick('unslick');
      }
      return;
    }

    if (!carousel.hasClass('slick-initialized')) {
      carousel.slick(settings);
    }

  }


  // either slick or stacked on pageload depending on breakpoint
  slickToggle($homePageCarousel, $homePageCarouselSettings, $homePageCarouselBP);


  // Listen for resize events
  let timeout;
  window.addEventListener('resize', () => {

    // If there's a timer, cancel it
    if (timeout) {
      window.cancelAnimationFrame(timeout);
    }

    // Setup the new requestAnimationFrame()
    timeout = window.requestAnimationFrame(() => {
      slickToggle($homePageCarousel, $homePageCarouselSettings, $homePageCarouselBP);
    });

  }, false);
};
